var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99997 2C4.8954 2 3.99997 2.89543 3.99997 4V5H7.99997V4C7.99997 2.89543 7.10454 2 5.99997 2ZM1.99997 4V5C1.17156 5.00002 0.5 5.67158 0.5 6.5V12.5C0.5 13.3284 1.17157 14 2 14H9.99997C10.8285 14 11.5 13.3284 11.5 12.5V6.5C11.5 5.67157 10.8285 5 9.99997 5V4C9.99997 1.79086 8.20911 0 5.99997 0C3.79083 0 1.99997 1.79086 1.99997 4ZM6 10.75C6.69036 10.75 7.25 10.1904 7.25 9.5C7.25 8.80964 6.69036 8.25 6 8.25C5.30964 8.25 4.75 8.80964 4.75 9.5C4.75 10.1904 5.30964 10.75 6 10.75Z",
    fill: "#5A616F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIcon);
export default __webpack_public_path__ + "static/media/padlockIcon.7a1a4d8380791e351cec6e01585491d6.svg";
export { ForwardRef as ReactComponent };